import { Store, Product, Order, Gift, SpecialDate, UserProfile } from '../types'

export const STORES: Store[] = [
  {
    id: '1',
    name: 'Bean & Leaf',
    image:
      'https://images.unsplash.com/photo-1509042239860-f550ce710b93?auto=format&fit=crop&w=800&q=80',
    distance: '0.2 mi',
    rating: 4.8,
    tags: ['Coffee', 'Bakery', 'Wifi'],
    hours: '7:00 AM - 8:00 PM',
    phone: '(555) 123-4567',
    storeId: 'BL-8821',
    description:
      'Artisanal coffee shop with house-made pastries and a cozy atmosphere.',
    address: '123 Main St, Downtown',
  },
  {
    id: '2',
    name: 'Urban Garden',
    image:
      'https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?auto=format&fit=crop&w=800&q=80',
    distance: '0.5 mi',
    rating: 4.6,
    tags: ['Food', 'Healthy', 'Vegan'],
    hours: '11:00 AM - 9:00 PM',
    phone: '(555) 987-6543',
    storeId: 'UG-4421',
    description: 'Fresh, farm-to-table salads and bowls.',
    address: '456 Market Ave',
  },
  {
    id: '3',
    name: 'Chapter One Books',
    image:
      'https://images.unsplash.com/photo-1507842217121-9e93c8ddd37f?auto=format&fit=crop&w=800&q=80',
    distance: '0.8 mi',
    rating: 4.9,
    tags: ['Books', 'Quiet', 'Coffee'],
    hours: '10:00 AM - 7:00 PM',
    phone: '(555) 456-7890',
    storeId: 'CO-1129',
    description:
      'Independent bookstore with a curated selection and reading nook.',
    address: '789 Library Ln',
  },
  {
    id: '4',
    name: 'Neon Arcade',
    image:
      'https://images.unsplash.com/photo-1511882150382-421056c89033?auto=format&fit=crop&w=800&q=80',
    distance: '1.2 mi',
    rating: 4.7,
    tags: ['Entertainment', 'Bar', 'Late Night'],
    hours: '4:00 PM - 2:00 AM',
    phone: '(555) 222-3333',
    storeId: 'NA-9988',
    description: 'Retro arcade games and craft cocktails.',
    address: '321 Night Blvd',
  },
  {
    id: '5',
    name: 'Golden Crust Pizza',
    image:
      'https://images.unsplash.com/photo-1513104890138-7c749659a591?auto=format&fit=crop&w=800&q=80',
    distance: '1.5 mi',
    rating: 4.5,
    tags: ['Food', 'Pizza', 'Family'],
    hours: '11:00 AM - 10:00 PM',
    phone: '(555) 777-8888',
    storeId: 'GC-5544',
    description: 'Wood-fired pizza with locally sourced toppings.',
    address: '555 Pizza Way',
  },
]

export const PRODUCTS: Record<string, Product[]> = {
  '1': [
    {
      id: 'p1',
      name: 'Latte',
      price: 4.5,
      category: 'Coffee',
      image:
        'https://images.unsplash.com/photo-1570968992193-d6ea06651af1?auto=format&fit=crop&w=400&q=80',
      description: 'Espresso with steamed milk',
    },
    {
      id: 'p2',
      name: 'Cappuccino',
      price: 4.25,
      category: 'Coffee',
      image:
        'https://images.unsplash.com/photo-1572442388796-11668a67e53d?auto=format&fit=crop&w=400&q=80',
      description: 'Espresso with foam',
    },
    {
      id: 'p3',
      name: 'Croissant',
      price: 3.75,
      category: 'Pastry',
      image:
        'https://images.unsplash.com/photo-1555507036-ab1f40388085?auto=format&fit=crop&w=400&q=80',
      description: 'Buttery flaky pastry',
    },
    {
      id: 'p4',
      name: 'Muffin',
      price: 3.5,
      category: 'Pastry',
      image:
        'https://images.unsplash.com/photo-1558401367-94467f57d2aa?auto=format&fit=crop&w=400&q=80',
      description: 'Blueberry muffin',
    },
  ],
  '2': [
    {
      id: 'p5',
      name: 'Kale Salad',
      price: 12.0,
      category: 'Salads',
      image:
        'https://images.unsplash.com/photo-1512621776951-a57141f2eefd?auto=format&fit=crop&w=400&q=80',
      description: 'Fresh kale with vinaigrette',
    },
    {
      id: 'p6',
      name: 'Quinoa Bowl',
      price: 14.5,
      category: 'Bowls',
      image:
        'https://images.unsplash.com/photo-1546069901-ba9599a7e63c?auto=format&fit=crop&w=400&q=80',
      description: 'Quinoa with roasted veggies',
    },
  ],
  '3': [
    {
      id: 'p7',
      name: 'The Great Gatsby',
      price: 15.99,
      category: 'Fiction',
      image:
        'https://images.unsplash.com/photo-1543002588-bfa74002ed7e?auto=format&fit=crop&w=400&q=80',
      description: 'Classic American novel',
    },
    {
      id: 'p8',
      name: 'Atomic Habits',
      price: 18.99,
      category: 'Self-Help',
      image:
        'https://images.unsplash.com/photo-1589829085413-56de8ae18c73?auto=format&fit=crop&w=400&q=80',
      description: 'Build better habits',
    },
  ],
}

export const MOCK_ORDERS: Order[] = [
  {
    id: 'ord-123',
    date: '2023-10-25',
    status: 'completed',
    total: 12.75,
    storeId: '1',
    storeName: 'Bean & Leaf',
    storeImage: STORES[0].image,
    items: [
      {
        id: 'p1',
        name: 'Latte',
        price: 4.5,
        category: 'Coffee',
        image: '',
        description: '',
        quantity: 2,
      },
      {
        id: 'p3',
        name: 'Croissant',
        price: 3.75,
        category: 'Pastry',
        image: '',
        description: '',
        quantity: 1,
      },
    ],
  },
  {
    id: 'ord-124',
    date: 'Today, 10:30 AM',
    status: 'preparing',
    total: 8.5,
    storeId: '1',
    storeName: 'Bean & Leaf',
    storeImage: STORES[0].image,
    items: [
      {
        id: 'p2',
        name: 'Cappuccino',
        price: 4.25,
        category: 'Coffee',
        image: '',
        description: '',
        quantity: 2,
      },
    ],
    isRecent: true,
  },
]

export const MOCK_GIFTS: Gift[] = [
  {
    id: 'g-1',
    itemId: 'p7',
    itemName: 'The Great Gatsby',
    itemImage:
      'https://images.unsplash.com/photo-1543002588-bfa74002ed7e?auto=format&fit=crop&w=400&q=80',
    itemPrice: 15.99,
    storeId: '3',
    storeName: 'Chapter One Books',
    storeImage: STORES[2].image,
    sender: 'Alice',
    recipient: 'You',
    message: 'Happy Birthday! Enjoy this classic read.',
    status: 'pending',
    date: '2023-10-20',
    code: 'GIFT-8821',
  },
  {
    id: 'g-2',
    itemId: 'p1',
    itemName: 'Latte',
    itemImage:
      'https://images.unsplash.com/photo-1570968992193-d6ea06651af1?auto=format&fit=crop&w=400&q=80',
    itemPrice: 4.5,
    storeId: '1',
    storeName: 'Bean & Leaf',
    storeImage: STORES[0].image,
    sender: 'You',
    recipient: 'Bob',
    message: 'Thanks for helping me move!',
    status: 'redeemed',
    date: '2023-09-15',
    code: 'GIFT-9912',
  },
  {
    id: 'g-3',
    itemId: 'p5',
    itemName: 'Kale Salad',
    itemImage:
      'https://images.unsplash.com/photo-1512621776951-a57141f2eefd?auto=format&fit=crop&w=400&q=80',
    itemPrice: 12.0,
    storeId: '2',
    storeName: 'Urban Garden',
    storeImage: STORES[1].image,
    sender: 'Sarah',
    recipient: 'You',
    message: 'Congrats on your promotion! 🎉',
    status: 'pending',
    date: '2023-10-22',
    code: 'GIFT-3344',
  },
]

export const MOCK_USER: UserProfile = {
  id: 'u-123456',
  name: 'Alex Johnson',
  email: 'alex@example.com',
  avatar:
    'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?auto=format&fit=crop&w=200&q=80',
  points: 1250,
  stamps: {
    '1': 7,
    '2': 3,
  },
  birthday: '05-14',
}

export const MOCK_DATES: SpecialDate[] = [
  {
    id: 'd1',
    name: "Mom's Birthday",
    date: '05-14',
    type: 'birthday',
    notes: 'Loves flowers',
  },
  { id: 'd2', name: 'Anniversary', date: '09-22', type: 'anniversary' },
]
